const routes = [
    {
        path: "/esl/module/dates",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: 'eslmoduledate_index'
        }
    }
];

export default routes;
